// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1534":"e8de3bd7","5777":"68da7c75","7538":"7d02d7b8","9427":"7d02d7b8"}[chunkId] + ".chunk.css";
};